import { useEffect } from 'react';
/**
 *  Хук, который отслеживает клик вне указанного родительского контейнера и выполняет колбек
 * @param indicator Индикатор это либо селектор родительского контейнера, либо его реф
 * @param cb вызываемый колбек
 */
export const useClickOutside = (indicator: HTMLElement | string | null, cb: () => void) => {
  useEffect(() => {
    if (!indicator) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (typeof indicator === 'string') {
        if (!(e.target as HTMLElement).closest(indicator)) {
          cb();
        }
      } else {
        if (indicator && !indicator.contains(e.target as Node)) {
          cb();
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [indicator, cb]);
};
